

export function formatValue(value) {
  return Intl.NumberFormat('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 0}).format(value)
}

export function clampPercent(value) {
  return Math.min(Math.max(value, 0), 1)
}



// WEBPACK FOOTER //
// ./state/utils.js